module.exports = __webpack_public_path__ + "img/krivina.66595cc9.svg";